import find from 'lodash/find';
import includes from 'lodash/includes';

import { Nullable } from 'chaika-frontend-types/frontend-cms';

import { translate } from '@chaika/i18n/helper';
import { TranslationValues } from '@chaika/i18n/types';

import type { OptionType } from '../Select';
import type { DefaultOption } from '../constants/constants';

export function makeValue(
    options: OptionType[],
    selectedValue: Nullable<string | number> | undefined,
    withDefaultValue: boolean | undefined,
): Nullable<OptionType> {
    const value = withDefaultValue ? (selectedValue ?? null) : selectedValue;

    return find(options, option => option.value === value) ?? null;
}

export function createDefaultOption(defaultOptionType: DefaultOption | TranslationValues): OptionType {
    return {
        value: null,
        label: translate(defaultOptionType),
    };
}

export function resolvePlaceholder(params: {
    forcePlaceholder?: boolean;
    placeholder?: string;
    title?: string;
    isOnFocus: boolean;
}): string | undefined {
    const { forcePlaceholder, placeholder, title, isOnFocus } = params;

    if (forcePlaceholder) {
        return placeholder;
    }
    if (title) {
        return '';
    }

    return isOnFocus ? translate('search') : placeholder;
}

export function isSameOptions(previous: OptionType[], next: OptionType[]): boolean {
    return previous.length === next.length && previous.every((option, index) => option.value === next[index]?.value);
}

export function makeValueFromSelected(options: OptionType[], selectedValues: string[] | number[]): OptionType[] {
    return options.filter(option => includes(selectedValues, option.value));
}
